// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1TUzM","productName":"Table_productName__1y7Z-"};